import { Draggable } from '@hello-pangea/dnd';
import { Box, alpha } from '@mui/material';
import React from 'react';

import { MuiSxProps } from '../../types';


interface IDragAndDropListItemProps {
  id: string;
  index: number;
  dataTest: string;
  children: React.ReactNode;
  containerStyles?: MuiSxProps;
  itemRef?: React.MutableRefObject<HTMLDivElement>;
  handleKeyDown?(e: React.KeyboardEvent): void;
}
export const DragAndDropListItem: React.FC<IDragAndDropListItemProps> = ({
  id,
  index,
  dataTest,
  containerStyles,
  children,
  itemRef,
  handleKeyDown
}) => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, { isDragging }) => {
        const setRefs = (node) => {
          provided.innerRef(node);
          if (itemRef && 'current' in itemRef) itemRef.current = node;
        };
        return (
          <Box
            data-test={dataTest}
            ref={setRefs}
            onKeyDown={(event) => {
              // Prevent arrow key navigation when dragging
              if (!isDragging) handleKeyDown(event);
            }}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            role="group"
            sx={{
              display: 'flex',
              flexGrow: 1,
              '.draggable-item': {
                backgroundColor: isDragging
                  ? (theme) => theme.palette.mode === 'dark'
                    ? alpha(theme.palette.primary.main, 0.2)
                    : theme.palette.primary.light
                  : undefined
              },
              ':focus-visible, &.Mui-focusVisible': {
                outline: (theme: any) => `2px solid ${theme.palette.primary.main}`,
                borderRadius: 1
              },
              ...containerStyles
            }}
          >
            {children}
          </Box>
        );
      }}
    </Draggable>
  );
};
